import { Pipe, PipeTransform } from '@angular/core';
import { Tache } from '../../models/tache';

@Pipe({
	name: 'filterTacheByName'
})
export class FilterTacheByNamePipe implements PipeTransform {
	transform(tache: Tache[], filter: string): Tache[] {
		if (
			!tache ||
			!filter ||
			tache === null ||
			filter === null ||
			filter === ''
		) {
			return tache;
		}

		return tache.filter((tache: Tache) => {
			if (tache.name) {
				// TODO: add lastName too
				return tache.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
